export default "__VITE_ASSET__RV1NEaTw__"